import { number, object } from 'yup'

const rateOfReturnOptions = []
let i = 3
while (i <= 12) {
  rateOfReturnOptions.push({
    label: `${i} %`,
    value: i,
  })
  i++
}

export const formFields = {
  proceeds: {
    label: `What insurance proceeds will your survivor receive upon your death?`,
    type: 'text',
    class: 'Currency',
  },
  annualNeeds: {
    label: `How much will your survivor require as an annual income?`,
    type: 'text',
    class: 'Currency',
  },
  rateOfReturn: {
    label: `What is your expected annual rate of return?`,
    type: 'select',
    options: rateOfReturnOptions,
  },
}

export const formSchema = object().shape({
  proceeds: number().typeError('must be a number').required('this is required'),
  annualNeeds: number()
    .typeError('must be a number')
    .required('this is required')
    .test('less', 'must be less than proceeds', (value, context) => {
      return value < context.parent.proceeds
    }),
  rateOfReturn: number()
    .typeError('must be a number')
    .required('this is required'),
})
